import { makeStyles, createStyles } from 'raydiant-elements/styles';
import { Theme } from 'raydiant-elements/theme';

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    headerContainer: {
      paddingTop: 0,
      paddingBottom: 0,
    },

    header: {
      margin: theme.spacing(1, 0),
      marginBottom: 0,
    },

    domainAccountSelector: {
      padding: theme.spacing(2),

      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(1),
      },
    },

    actions: {
      marginTop: theme.spacing(1),
      padding: theme.spacing(1),
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },

    libraryContainer: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      paddingTop: 0,

      '&:last-child': {
        paddingBottom: 0,
      },
    },

    library: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      padding: theme.spacing(1),
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
    },

    libraryEmpty: {
      flex: 1,
      alignItems: 'center',
      backgroundImage: `url(${
        require('../../assets/library-tree-skeleton.svg').default
      })`,
      backgroundPosition: 'top center',
      backgroundRepeat: 'repeat',
      backgroundSize: '100%',
      lineHeight: 1.09,
      letterSpacing: 0.25,
      textAlign: 'center',
      padding: theme.spacing(4, 2),
    },
  });
});

export default useStyles;
